import DraggableTableRows   from './draggable-table-rows.js';
import ExpandableTable      from './table-expandable-rows.js';
import JoinLeagueModal      from './join-private-league.js';
import MakePayment          from './make-payment.js';
import PicksFormValidator   from './picks-form-validator';
import SendNotifications    from './send-notifications.js';
import ToggleSwitch         from './toggle-switch.js';
import TrendCharts          from './trend-charts';
import UpdatePayments       from './update-payments.js';
import WeeklyResults        from './weekly-results.js';
import Chatbox              from './chatbox.js';

document.addEventListener('DOMContentLoaded', () => {
    new ExpandableTable();
    new DraggableTableRows();
    new TrendCharts();
    new PicksFormValidator();
    new WeeklyResults();
    new UpdatePayments();
    new MakePayment();
    new SendNotifications();
    new Chatbox();

    if (document.querySelector('#join-league-form')) {
        JoinLeagueModal();
    }

    document.querySelectorAll('.toggle-switch')
        .forEach(el => new ToggleSwitch(el));

});